<template>
  <div class="questions-list-container" data-testid="questions-list-container">
    <label>
      <slot name="title" />
    </label>
    <md-card class="questions-list-card">
      <md-card-content class="questions-list-card-content" data-testid="questions-list">
        <md-content class="md-scrollbar" style="height: 300px; overflow: auto">
          <div v-for="question in questions" :key="question.id" class="question" data-testid="question-in-list">
            <span aria-label="Question content" data-testid="question-content">{{ question.content.en }}</span>
            <md-button
              v-for="action in actions"
              :key="action.name"
              :aria-label="`${action.name} question`"
              :data-testid="`${action.name}-question-button`"
              class="md-raised md-primary md-icon-button question-button"
              @click="onQuestionAction(question, action)"
            >
              <md-icon>{{ action.icon }}</md-icon>
            </md-button>
          </div>
        </md-content>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>

export default {
  name: 'questions-list',
  components: {
  },
  props: {
    questions: {
      type: Array,
      default: () => [],
    },
    actions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  computed: {
  },
  methods: {
    onQuestionAction(question) {
      this.$emit('questionActionClick', question);
    },
  },
};
</script>

<style scoped>
.questions-list-container {
  flex: 1;
}

.questions-list-container:first-child {
  margin-right: 14px;
}

.questions-list-card-content {
  padding-bottom: 0 !important;
  padding: 1px;
}

.question {
  padding: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: solid 0.5px #d4d4d4;
}

label {
  display: block;
  margin-bottom: 10px;
}
</style>
